import { initTrackingClient } from '../../libs/algolia-service/algolia-tracking-init'

const initAlgoliaTracking = async () => {
  if (!window.instanceAlgoliaTracking) {
    window.instanceAlgoliaTracking = initTrackingClient()
    window.instanceAlgoliaTracking.init()
  }
}

initAlgoliaTracking()
